import { render, staticRenderFns } from "./MessagerViewMessage.vue?vue&type=template&id=497d1d99&scoped=true&"
import script from "./MessagerViewMessage.vue?vue&type=script&lang=js&"
export * from "./MessagerViewMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessagerViewMessage.vue?vue&type=style&index=0&id=497d1d99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d1d99",
  null
  
)

export default component.exports